import React from 'react';
import PropTypes from 'prop-types';
import Header from '../../containers/Header/Header';
import Footer from '../Footer/Footer';
import ErrorModal from '../Modal/ErrorModal';
import {AppRoute} from '../../routes/Route';
import {ContainerStyled} from '../../styles/components/container.style';
import {AppWrapperStyled, Background} from './template.style';
import {getBackgroundImage} from '../../helpers/string.helper';
import SmartBanner from '../SmartBanner/SmartBanner';

export const DarkTemplate = (restaurant, config, navUrls) => {
  const {
    language,
    template,
    extraInfo,
    isTradeShow,
    showGalleryPage,
    isExpandedFooter,
    offlineMenus,
    mobileOS
  } = config;
  const backgroundImageUrl = restaurant.backgroundImages && restaurant.backgroundImages.desktop;
  const backgroundImages = getBackgroundImage(backgroundImageUrl);

  const renderBackground = !restaurant.modes.offlineMode && (
    <Background backgroundImages={backgroundImages} />
  );
  const renderSmartBanner = (
    <SmartBanner
      position="top"
      force={mobileOS}
    />
  );
  return (
    <AppWrapperStyled>
      <ErrorModal />
      <Header
        extraInfo={extraInfo}
        modes={restaurant.modes}
        logoUrl={restaurant.imageLogoUrl}
        restaurantName={restaurant.name}
        address={restaurant.address.singleLine}
        tel={restaurant.contactNumber}
        specialHeader={isTradeShow}
        headerColor={template.headerColour}
        showGalleryPage={showGalleryPage}
        offlineMenus={offlineMenus}
        externalWebsiteUrl={restaurant.externalWebsiteUrl}
        navigationMenu={template.navigationMenu}
        showReviewPage={!showGalleryPage && !!restaurant.thirdPartyServices}
        navUrls={navUrls}
      />
      {renderSmartBanner}
      <ContainerStyled>
        <AppRoute />
      </ContainerStyled>
      <Footer
        name={restaurant.name}
        language={language}
        expand={isExpandedFooter}
        extraIndent={isTradeShow}
        navUrls={navUrls}
      />
      {renderBackground}
    </AppWrapperStyled>
  );
};

DarkTemplate.propTypes = {
  restaurant: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  navUrls: PropTypes.object
};



// WEBPACK FOOTER //
// ./components/ThemeAllocator/DarkTemplate.js